(() => {
  if (window.AyaaniPdpAjaxCartV1) return;
  window.AyaaniPdpAjaxCartV1 = true;

  const formSelector = '.aym-pdp form.aym-form[action*="/cart/add"]';

  function getErrorElement(form) {
    let element = form.querySelector('[data-ayaani-ajax-cart-error]');
    if (element) return element;

    element = document.createElement('p');
    element.dataset.ayaaniAjaxCartError = '';
    element.setAttribute('role', 'alert');
    element.setAttribute('aria-live', 'polite');
    element.hidden = true;
    element.style.cssText = 'margin:10px 0 0;color:#8b0f27;font-size:14px;line-height:1.4;';
    form.appendChild(element);
    return element;
  }

  function showError(form, message = '') {
    const element = getErrorElement(form);
    element.textContent = message;
    element.hidden = !message;
  }

  function setLoading(form, loading) {
    const buttons = Array.from(form.querySelectorAll('button[type="submit"], input[type="submit"]'));

    buttons.forEach((button) => {
      if (loading) {
        if (!button.dataset.ayaaniOriginalDisabled) {
          button.dataset.ayaaniOriginalDisabled = button.disabled ? 'true' : 'false';
        }
        if (button.tagName === 'INPUT') {
          if (!button.dataset.ayaaniOriginalLabel) button.dataset.ayaaniOriginalLabel = button.value;
          button.value = 'Adding…';
        } else {
          if (!button.dataset.ayaaniOriginalLabel) button.dataset.ayaaniOriginalLabel = button.innerHTML;
          button.textContent = 'Adding…';
        }
        button.disabled = true;
        button.setAttribute('aria-disabled', 'true');
      } else {
        if (button.tagName === 'INPUT') {
          button.value = button.dataset.ayaaniOriginalLabel || 'Add to basket';
        } else {
          button.innerHTML = button.dataset.ayaaniOriginalLabel || 'Add to basket';
        }
        button.disabled = button.dataset.ayaaniOriginalDisabled === 'true';
        if (button.disabled) button.setAttribute('aria-disabled', 'true');
        else button.removeAttribute('aria-disabled');
        delete button.dataset.ayaaniOriginalLabel;
        delete button.dataset.ayaaniOriginalDisabled;
      }
    });
  }

  async function submitWithDrawer(event) {
    const form = event.currentTarget;
    event.preventDefault();

    if (form.dataset.ayaaniAjaxPending === 'true') return;

    const cart = document.querySelector('cart-drawer') || document.querySelector('cart-notification');
    if (!cart || typeof cart.renderContents !== 'function' || typeof cart.getSectionsToRender !== 'function') {
      HTMLFormElement.prototype.submit.call(form);
      return;
    }

    const variantInput = form.querySelector('[name="id"]');
    if (!variantInput || !variantInput.value) {
      showError(form, 'Please select an available product option.');
      return;
    }

    const activeButton = event.submitter || form.querySelector('[type="submit"]') || document.activeElement;
    form.dataset.ayaaniAjaxPending = 'true';
    showError(form, '');
    setLoading(form, true);

    try {
      if (typeof cart.setActiveElement === 'function') cart.setActiveElement(activeButton);

      const formData = new FormData(form);
      const sections = cart.getSectionsToRender().map((section) => section.id).filter(Boolean);
      formData.append('sections', sections.join(','));
      formData.append('sections_url', window.location.pathname);

      const response = await fetch(window.routes?.cart_add_url || '/cart/add.js', {
        method: 'POST',
        headers: {
          Accept: 'application/json',
          'X-Requested-With': 'XMLHttpRequest',
        },
        body: formData,
      });

      const result = await response.json();
      if (!response.ok || result.status) {
        throw new Error(result.description || result.message || 'This product could not be added.');
      }

      cart.classList.remove('is-empty');

      try {
        if (typeof window.publish === 'function' && window.PUB_SUB_EVENTS?.cartUpdate) {
          await Promise.resolve(window.publish(window.PUB_SUB_EVENTS.cartUpdate, {
            source: 'ayaani-pdp-ajax-cart',
            productVariantId: formData.get('id'),
            cartData: result,
          }));
        }
      } catch (eventError) {
        console.warn('[Ayaani AJAX cart] Cart update event could not be published.', eventError);
      }

      cart.renderContents(result);
    } catch (error) {
      console.error('[Ayaani AJAX cart] Add to basket failed.', error);
      showError(form, error.message || 'This product could not be added. Please try again.');
    } finally {
      delete form.dataset.ayaaniAjaxPending;
      setLoading(form, false);
    }
  }

  function bindForms(root = document) {
    const forms = [];
    if (root.matches?.(formSelector)) forms.push(root);
    root.querySelectorAll?.(formSelector).forEach((form) => forms.push(form));

    forms.forEach((form) => {
      if (form.dataset.ayaaniAjaxCartBound === 'true' || form.closest('product-form')) return;
      form.dataset.ayaaniAjaxCartBound = 'true';
      form.setAttribute('data-type', 'add-to-cart-form');
      form.querySelectorAll('[type="submit"]').forEach((button) => button.setAttribute('aria-haspopup', 'dialog'));
      form.addEventListener('submit', submitWithDrawer);
    });
  }

  function initialise() {
    bindForms(document);
    document.addEventListener('shopify:section:load', (event) => bindForms(event.target));
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialise, { once: true });
  } else {
    initialise();
  }
})();
